import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Header, Footer } from '../components';
import { userActions } from '../store/actions';
import '../Styles/policy.css';
import { renderHTML } from '../helpers';
import Tracking from '../services/tracking.service';
import { PAGENAME_CONSTANTS } from '../constants';

const IUBENTA_POLICY_ID = 61218797;

class PrivacyPolicy extends Component {

    constructor(props) {
        super(props)
        this.state = {
            policy_text: null,
        }

        const { dispatch } = this.props;
        // Check user Token validation with DB Token
        dispatch(userActions.getPrivacyPolicy(IUBENTA_POLICY_ID, "privacy"));
        // Mixpanel Tracking Code Start
        Tracking.trackPage({pageName: PAGENAME_CONSTANTS.PRIVACY_POLICY})
        // Mixpanel Tracking Code End
    }

    render() {
        const update_privacy_policy = this.props.update_privacy_policy;
        return (
            <React.Fragment>
                <Header />
                <main className="data-not-avaibale">
                    <div className="container" style={{ minHeight: '520px' }}>
                        <div className="center-box">
                            {update_privacy_policy && renderHTML(update_privacy_policy)}
                        </div>
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        update_privacy_policy: state.authentication.update_privacy_policy
    };
}

const connectedPrivacyPolicy = connect(mapStateToProps, null, null, {
    pure: false
})(PrivacyPolicy);

export { connectedPrivacyPolicy as PrivacyPolicy };
